<template>
  <div class="regist">
    <div class="left-rect">
      <div class="logo">
        <img src="/assets/images/logo.svg"/>
      </div>
    </div>
    <div class="right-rect">
      <div class="logo">
        <img src="/assets/images/logo.svg"/>
      </div>
      <a-form
        labelAlign="left"
        :model="user"
        @finish="regist"
        :labelCol="{ span: 6 }"
        :wrapperCol="{ span: 16 }"
        autocomplete="off"
        class='regist-form'>
        <div style="margin: 32px auto 6px; font-size: 32px; width: fit-content; font-weight: bold;">
          <span>Vertex</span>
        </div>
        <div style="margin: 6px auto 32px; font-size: 16px; width: fit-content; color: grey">
          <span>追剧刷流一体化工具</span>
        </div>
        <a-form-item
          label="用户名"
          name="username"
          :rules="[{ required: true, message: '${label}输入非法! ', pattern: /[a-zA-Z][a-zA-Z0-9]{3}/ }]">
          <a-input v-model:value="user.username"/>
        </a-form-item>
        <a-form-item
          label="邮箱"
          name="email"
          :rules="[{ required: true, message: '${label}输入非法! ', type: 'email' }]">
          <a-input v-model:value="user.email"/>
        </a-form-item>
        <a-form-item
          label="昵称"
          name="nickname"
          :rules="[{ required: true, message: '${label}输入非法! ', pattern: /.{2}/ }]">
          <a-input v-model:value="user.nickname"/>
        </a-form-item>
        <a-form-item
          label="密码"
          name="password"
          :rules="[{ required: true, message: '${label}输入非法! ', pattern: /.{6}/ }]">
          <a-input-password v-model:value="user.password"/>
        </a-form-item>
        <a-form-item
          label="注册码"
          name="registCode"
          :rules="[{ required: true, message: '注册码不能为空! ' }]">
          <a-input v-model:value="user.registCode"/>
        </a-form-item>
        <a-form-item
          :wrapperCol="{ span: 24 }">
          <a-button type="primary" html-type="submit" block style="width: 100%; margin-top: 24px; margin-bottom: 48px;">注册</a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    const user = {
      username: '',
      password: '',
      nickname: '',
      email: '',
      registCode: ''
    };
    return {
      user
    };
  },
  methods: {
    async regist () {
      try {
        await this.$api().user.regist({ ...this.user });
        this.$message().success('注册成功, 3 秒后跳转至登录页');
        setTimeout(() => this.$goto('/user/login', this.$router), 3000);
      } catch (e) {
        this.$message().error(e.message);
      }
    }
  }
};
</script>

<style scoped>
.regist-form {
  width: min(100vw, 360px);
  border-radius: 4px;
  padding: 12px;
  margin: 0 auto;
  height: 360px;
  transition: all 0.5s;
}

.left-rect {
  float: left;
  transition: all 0.5s;
}

.right-rect {
  float: left;
}

.logo {
  transition: all 0.5s;
}

@media screen and (min-width:800px) {
  .regist-form {
    margin-top: calc(50vh - 400px);
  }
  .left-rect {
    width: 300px;
    background: #e18dac;
    height: 100vh;
  }
  .right-rect {
    width: calc(100vw - 320px);
    height: 100vh;
  }
  .left-rect > .logo {
    margin: 0 auto;
    width: 180px;
    padding-top: calc(50vh - 180px);
    border-radius: 32px;
  }
  .right-rect > .logo {
    overflow: hidden;
    height: 0;
    margin: 0 auto;
    width: 160px;
    padding-top: 64px;
    border-radius: 32px;
  }
}

@media screen and (max-width:800px) {
  .left-rect {
    width: 0;
    background: #e18dac;
    height: 100vh;
    overflow: hidden;
  }
  .right-rect {
    width: 100vw;
    height: 100vh;
    transition: all 0.5s;
  }
  .left-rect > .logo {
    overflow: hidden;
    margin: 0 auto;
    width: 0;
    border-radius: 32px;
    padding-top: calc(50vh - 180px);
  }
  .right-rect > .logo {
    margin: 0 auto;
    width: 120px;
    padding-top: 32px;
    border-radius: 32px;
  }
}
</style>
